(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-bundle"] && !Shopify.designMode) return;
  try {
    

  $(function(){

    $('select').change(function(){
       var selected = $(this).find('option:selected');
       var price = selected.data('price');

       var price1 = $("#planner1").find('option:selected').data('price');
       var price2 = $("#planner2").find('option:selected').data('price');
       var price3 = $("#planner3").find('option:selected').data('price');
       var price4 = $("#planner4").find('option:selected').data('price');

       var totalPrice = price1 + price2 + price3 + price4;
      
       //alert('Price: ' + totalPrice);

       $('#bundleTotalPrice').text(totalPrice);
      
    });
  });




  document.getElementById('addToCart').addEventListener('click', async () => {
    const variantId = '44430301692201';
    const selection = {
      externalVariantId: variantId,
      externalProductId: '8117469380905',
      selections: [
        {
          collectionId: '145205', // collection1
          externalProductId: '8125023060265',
          externalVariantId: '44453556486441', // this product must exist in collection1
          quantity: 2,
        },
        {
          collectionId: '145205', // collection2
          externalProductId: '8125023060265',
          externalVariantId: '44453556519209', // this product must exist in collection2
          quantity: 2,
        },
      ],
    };

  
    recharge.init({
      // this should be your myshopifyUrl
      //storeIdentifier: 'michael-hyatt-company.myshopify.com',
      // this should be your Recharge Storefront Access Token
      //storefrontAccessToken: 'storefrontAccessToken',
    });
    
    console.log({ bundleConfiguration: await recharge.cdn.getCDNBundleSettings(8117469380905) });

    const _rb_id = await recharge.bundle.getBundleId(selection, {});

    
    const data = {
      items: [
        {
          id: variantId,
          quantity: 1,
          selling_plan: 688766910761,
          properties: {
            _rb_id, // this is the only require attribute - which links the bundle to this particular line item
          },
        },
      ],
    };

    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    window.location.href = '/cart';
    
  });

  console.log('v4');
  

  } catch(e) { console.error(e); }
})();
})();
